export const TWA_REFERRER = 'android-app://org.familysearch.www.together_twa'

// Session-scoped record that this browsing context was launched by the Together Android app.
const SESSION_KEY = 'is_twa_mode'

const hasTwaReferrer = () => {
  const referrer = document.referrer ?? ''
  return referrer === TWA_REFERRER || referrer.startsWith(`${TWA_REFERRER}/`)
}

// `?twa=1`, forwarded by discovery-kids on in-app links. Unlike storage or the referrer it survives a
// cross-origin hop, which is what makes local dev work.
const hasTwaParam = () => {
  try {
    return new URLSearchParams(window.location.search).get('twa') === '1'
  } catch {
    return false
  }
}

const isTwaLaunch = () => hasTwaParam() || hasTwaReferrer()

/**
 * Records the launch signals for the rest of the session. Call once at startup, before the router runs.
 *
 * Both signals are only readable on the entry document — the router strips the query string on the first
 * client-side navigation, and the referrer changes on the next page load.
 */
export function captureTwaMode() {
  if (typeof window === 'undefined') return

  try {
    // One-time heal for browsers still carrying the flag the old localStorage check wrote.
    window.localStorage.removeItem(SESSION_KEY)
  } catch {
    // ignore
  }

  if (!isTwaLaunch()) return

  try {
    window.sessionStorage.setItem(SESSION_KEY, 'true')
  } catch {
    // Nothing useful to do — detection degrades to web behavior, which is the safe direction.
  }
}

export default function getIsTWAMode() {
  if (typeof window === 'undefined') return false

  try {
    if (window.sessionStorage.getItem(SESSION_KEY) === 'true') return true
  } catch {
    // sessionStorage access throws in some locked-down webviews; fall through to the live signals.
  }

  if (!isTwaLaunch()) return false

  captureTwaMode()
  return true
}
